"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function HeroIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="15748" id="contact-hero" className="relative flex min-h-[60vh] w-full items-center justify-center overflow-hidden py-16 text-white !opacity-[1] !bg-[rgba(27,132,57,0.03)]" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:hzi4uz" data-ast-start="395" data-ast-end="2907">
      {}
      <div className="absolute inset-0 pointer-events-none select-none" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:erthu1" data-ast-start="588" data-ast-end="1271">
        {}
        
        {}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `linear-gradient(to right, #d1d5db 1px, transparent 1px), linear-gradient(to bottom, #d1d5db 1px, transparent 1px)`,
        backgroundSize: '40px 40px',
        maskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, black 40%, transparent 100%)'
      }} data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:rxlflx" data-ast-start="694" data-ast-end="1030" />

        {}
        <div className="absolute bottom-0 left-1/2 h-[60%] w-[80%] -translate-x-1/2 translate-y-1/4 rounded-[100%] bg-[radial-gradient(circle_at_center,var(--primary)_0%,transparent_70%)] opacity-20 blur-[100px]" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:8au9qk" data-ast-start="1051" data-ast-end="1258" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto flex flex-col items-center px-4 text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0")} data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:9k8vgx" data-ast-start="1288" data-ast-end="2892" data-attr-property-mappings="ref:ref">
        {}
        <h1 className="mb-8 max-w-5xl font-sans text-5xl font-extrabold tracking-tighter text-white uppercase sm:text-6xl md:text-7xl" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:anw8vu" data-ast-start="1525" data-ast-end="1800">
          <span className="!font-sans text-primary" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:jcjqni" data-ast-start="1667" data-ast-end="1786">GET IN TOUCH</span>
        </h1>

        {}
        <p className="mb-10 max-w-2xl text-lg md:text-xl text-secondary" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:nvlbxp" data-ast-start="1821" data-ast-end="2019">Garage door expertise available 24/7 for repair, installation, and same-day service in Kingwood, TX and surrounding areas.</p>

        {}
        <div className="mb-12 flex flex-col items-center gap-4 sm:flex-row" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:hb7bn2" data-ast-start="2040" data-ast-end="2573">
          {}
          <Button asChild size="lg" className="bg-primary text-white rounded-md px-4 py-2 font-medium" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:toxphy" data-ast-start="2132" data-ast-end="2329">
            <Link to="tel:713-304-4798" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:ay9k8m" data-ast-start="2238" data-ast-end="2309">
              Call Now
            </Link>
          </Button>

          <Button asChild size="lg" className="bg-primary text-white rounded-md px-4 py-2 font-medium hover:bg-primary/90" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:qyorb9" data-ast-start="2341" data-ast-end="2558">
            <Link to="sms:713-304-4798" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:ax42u0" data-ast-start="2467" data-ast-end="2538">
              Text Now
            </Link>
          </Button>
        </div>

        {}
        <div className="flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-4 py-2 font-sans text-sm tracking-wide backdrop-blur-sm text-secondary !border-[rgba(0,0,0,1)] border-1 border-solid" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:ea2mcl" data-ast-start="2594" data-ast-end="2879">
          <ShieldCheck className="size-4 text-primary" data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:wua5h3" data-ast-start="2769" data-ast-end="2816" />
          <span data-ast-id="f:/src/pages/ContactUs/sections/HeroIntroduction.tsx|sig:hz63cf" data-ast-start="2827" data-ast-end="2864">VETERAN OWNED & OPERATED</span>
        </div>
      </div>
    </section>;
}